import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col q-ma-md" }
const _hoisted_3 = { class: "col q-ma-md" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col q-ma-md" }
const _hoisted_6 = { class: "col q-ma-md" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "col q-pa-md",
  style: {"max-width":"300px"}
}
const _hoisted_9 = { class: "row items-center justify-end" }
const _hoisted_10 = {
  class: "col q-pa-md",
  style: {"max-width":"300px"}
}
const _hoisted_11 = { class: "row items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_date = _resolveComponent("q-date")
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_form = _resolveComponent("q-form")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_component_q_form, { ref: "form" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_q_select, {
            loading: _ctx.watcher,
            disable: _ctx.watcher,
            clearable: "",
            filled: "",
            modelValue: _ctx.filtro.agrupacion,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filtro.agrupacion = $event)),
            "use-input": "",
            "map-options": "",
            "option-value": "id",
            "option-label": "descripcion",
            "stack-label": "",
            "input-debounce": "0",
            label: "Agrupación",
            options: _ctx.agrupaciones,
            behavior: "menu",
            onFilter: _ctx.filterAgrupaciones,
            rules: [_ctx.validarSelect],
            hint: "Seleccione una agrupación"
          }, null, 8, ["loading", "disable", "modelValue", "options", "onFilter", "rules"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_q_select, {
            clearable: "",
            filled: "",
            modelValue: _ctx.filtro.profesion,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filtro.profesion = $event)),
            "use-input": "",
            "map-options": "",
            "option-value": "id",
            "option-label": "descripcion",
            "stack-label": "",
            "input-debounce": "0",
            label: "Título",
            options: _ctx.profesiones,
            behavior: "menu",
            onFilter: _ctx.filterProfs,
            disable: !_ctx.filtro.agrupacion || !_ctx.filtro.agrupacion.length === 0,
            rules: [_ctx.validarSelect],
            hint: "Seleccione un título"
          }, null, 8, ["modelValue", "options", "onFilter", "disable", "rules"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_q_select, {
            clearable: "",
            filled: "",
            modelValue: _ctx.filtro.fuero,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filtro.fuero = $event)),
            "use-input": "",
            "map-options": "",
            "option-value": "id",
            "option-label": "descripcion",
            "stack-label": "",
            "input-debounce": "0",
            label: "Fuero",
            options: _ctx.fueros,
            behavior: "menu",
            onFilter: _ctx.filterFueros,
            rules: [_ctx.validarSelect],
            hint: "Seleccione un fuero"
          }, null, 8, ["modelValue", "options", "onFilter", "rules"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_q_select, {
            clearable: "",
            filled: "",
            modelValue: _ctx.filtro.zona,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filtro.zona = $event)),
            "use-input": "",
            "map-options": "",
            "option-value": "id",
            "option-label": "descripcion",
            "stack-label": "",
            "input-debounce": "0",
            label: "Zona",
            options: _ctx.zonas,
            behavior: "menu",
            onFilter: _ctx.filterZonas,
            disable: !_ctx.filtro.fuero || !_ctx.filtro.fuero.length === 0,
            rules: [_ctx.validarSelect],
            hint: "Seleccione una zona"
          }, null, 8, ["modelValue", "options", "onFilter", "disable", "rules"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_q_input, {
            readonly: "",
            filled: "",
            modelValue: _ctx.filtro.fechaDesde,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filtro.fechaDesde = $event)),
            label: "Fecha desde",
            mask: "##-##-####",
            rules: [_ctx.validarFecha]
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "event",
                class: "cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_popup_proxy, {
                    ref: "qDateProxy",
                    "transition-show": "scale",
                    "transition-hide": "scale"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_date, {
                        modelValue: _ctx.filtro.fechaDesde,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filtro.fechaDesde = $event)),
                        mask: "DD-MM-YYYY",
                        options: _ctx.optionsFn,
                        "navigation-min-year-month": _ctx.minMonYear,
                        "navigation-max-year-month": _ctx.maxMonYear
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_9, [
                            _withDirectives(_createVNode(_component_q_btn, {
                              label: "Cerrar",
                              color: "primary",
                              flat: ""
                            }, null, 512), [
                              [_directive_close_popup]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "navigation-min-year-month", "navigation-max-year-month"])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_q_input, {
            filled: "",
            readonly: "",
            modelValue: _ctx.filtro.fechaHasta,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filtro.fechaHasta = $event)),
            label: "Fecha hasta",
            mask: "##-##-####",
            rules: [_ctx.validarFecha, _ctx.validarMayor]
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "event",
                class: "cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_popup_proxy, {
                    ref: "qDateProxy",
                    "transition-show": "scale",
                    "transition-hide": "scale"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_date, {
                        modelValue: _ctx.filtro.fechaHasta,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filtro.fechaHasta = $event)),
                        mask: "DD-MM-YYYY",
                        options: _ctx.optionsFn,
                        "navigation-min-year-month": _ctx.minMonYear,
                        "navigation-max-year-month": _ctx.maxMonYear
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_11, [
                            _withDirectives(_createVNode(_component_q_btn, {
                              label: "Cerrar",
                              color: "primary",
                              flat: ""
                            }, null, 512), [
                              [_directive_close_popup]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "navigation-min-year-month", "navigation-max-year-month"])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}